import { useSelector } from 'react-redux';
import { metricsSelector } from '../../wave/selectors/wave.selectors';
import { MetricCard } from './MetricCard';
import { Divider, HStack } from '@cdl/heartbeat-react';

export const ShrMetrics: React.FC = () => {
  const metrics = useSelector(metricsSelector);

  if (metrics.length === 0) {
    return <div />;
  }

  return (
    <HStack
      bgColor='neutral.0'
      spacing='s'
      p='s'
      borderRadius='4px'
      divider={<Divider orientation='vertical' />}
      shadow={400}
    >
      {metrics.map((metric, i) => (
        <MetricCard
          key={i}
          label={metric.description}
          value={metric.value}
          metricUnit={metric.unit}
          color={metric.color}
        />
      ))}
    </HStack>
  );
};
